import { render, staticRenderFns } from "./AgendaListOfSessions.vue?vue&type=template&id=5faf1535&scoped=true&"
import script from "./AgendaListOfSessions.vue?vue&type=script&lang=js&"
export * from "./AgendaListOfSessions.vue?vue&type=script&lang=js&"
import style0 from "./AgendaListOfSessions.vue?vue&type=style&index=0&id=5faf1535&lang=scss&scoped=true&"
import style1 from "./AgendaListOfSessions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf1535",
  null
  
)

export default component.exports